import type { ReactNode } from "react";
import { CustomCard, CustomTypography } from "sipli-fleet-core/components";

const { CustomTitle } = CustomTypography;

export const DetailsReadOnlyField = ({
  label,
  value,
  className = "",
}: {
  label: ReactNode;
  value?: ReactNode;
  className?: string;
}) => (
  <div className={`min-w-0 ${className}`}>
    <div className="mb-2 text-sm font-normal text-black">{label}</div>
    <div className="min-h-8 break-words text-[14px] font-semibold leading-[18px] text-black">
      {value === undefined || value === null || value === "" ? "--" : value}
    </div>
  </div>
);

const DetailsCard = ({
  title,
  extra,
  children,
}: {
  title: ReactNode;
  extra?: ReactNode;
  children: ReactNode;
}) => (
  <CustomCard
    className="!rounded-[16px] !border !border-gray3 shadow-none [&_.ant-card-head]:!border-b-0 [&_.ant-card-head]:!p-[0px_16px] [&_.ant-card-body]:!p-[12px_16px_24px_16px] [&_.ant-form-item-label>label]:!text-black"
    title={
      <CustomTitle
        level={5}
        className="!mb-0 !text-[17.72px] !font-bold !leading-[28px] !text-black"
      >
        {title}
      </CustomTitle>
    }
    extra={extra ? <span className="text-sm font-semibold text-gray8">{extra}</span> : undefined}
  >
    {children}
  </CustomCard>
);

export default DetailsCard;
